import { useEffect } from 'react';
import './FloralHealingAnimation.css';

export default function FloralHealingAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl) return;

    const container = playerEl.closest('.battle-screen') || playerEl.closest('.battle-container') || document.body;
    const containerRect = container.getBoundingClientRect();

    const playerRect = playerEl.getBoundingClientRect();
    const playerX = Math.round((playerRect.left + playerRect.width / 2) - containerRect.left);
    const playerY = Math.round((playerRect.top + playerRect.height / 2) - containerRect.top);

    const elements = [];

    playerEl.classList.add('floral-healing-user-channel');

    const ring = document.createElement('div');
    ring.className = 'floral-healing-soft-ring';
    ring.style.left = `${playerX - 42}px`;
    ring.style.top = `${playerY - 42}px`;
    ring.style.width = '84px';
    ring.style.height = '84px';
    container.appendChild(ring);
    elements.push(ring);

    for (let i = 0; i < 8; i++) {
      const spark = document.createElement('div');
      spark.className = 'floral-healing-spark';
      const sx = playerX + (Math.random() - 0.5) * 54;
      const sy = playerY + (Math.random() - 0.5) * 40;
      spark.style.left = `${sx - 3}px`;
      spark.style.top = `${sy - 3}px`;
      spark.style.animationDelay = `${i * 30}ms`;
      container.appendChild(spark);
      elements.push(spark);
    }

    for (let i = 0; i < 3; i++) {
      const plus = document.createElement('div');
      plus.className = 'floral-healing-plus';
      const px = playerX + (Math.random() - 0.5) * 36;
      const py = playerY + (Math.random() - 0.5) * 30;
      plus.style.left = `${px - 6}px`;
      plus.style.top = `${py - 8}px`;
      plus.style.animationDelay = `${120 + i * 90}ms`;
      plus.textContent = '+';
      container.appendChild(plus);
      elements.push(plus);
    }

    const cleanupTimer = setTimeout(() => {
      playerEl.classList.remove('floral-healing-user-channel', 'floral-healing-user-bloom');
      elements.forEach(item => {
        if (item.type === 'timer') {
          clearTimeout(item.timer);
        } else if (item && item.parentNode) {
          item.remove();
        }
      });
      onComplete();
    }, 850);

    return () => {
      clearTimeout(cleanupTimer);
      playerEl.classList.remove('floral-healing-user-channel', 'floral-healing-user-bloom');
      elements.forEach(item => {
        if (item.type === 'timer') {
          clearTimeout(item.timer);
        } else if (item && item.parentNode) {
          item.remove();
        }
      });
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

FloralHealingAnimation.moveType = 'fairy';
